import "./PoliciesGuidelinesSafety.module.css";
import Header from "@/reusable_sections/Header";
import Policy from "./sections/Policy";
import Services from "./sections/Services";
import Standards from "./sections/Standards";
import Policyandlegalgrid from "./sections/Policyandlegalgrid";
import Policies from "./sections/Policies";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function PoliciesGuidelinesSafetyPage() {
  return <div>
      <Header />
      <Policy />
      <Services />
      <Standards />
      <Policyandlegalgrid />
      <Policies />
      <Inquiry />
      <Footer />
    </div>;
}